import React, { useState, useEffect } from "react";
import { Loader, Modal, Form, Dropdown } from "semantic-ui-react";

import { Country } from "country-state-city";
import { toast } from "react-toastify";
import { selectTranslations } from "../../../config/i18n/slice";
import { useSelector } from "react-redux";
import moment from "moment";
import { CloseIcon } from "../../../../Assets/Icons/svg";
import { DeactivatePeople } from "../../../config/api/peopleApis";

function Personal({
  targetedData,
  createdByUserData,
  setRefresh,
  refresh,
  untoggle,
  setTargetData,
  setFilterOptions,
  setSearchTitle,
  setSortData,
  setTogglePreviw,
}) {
  const t = useSelector(selectTranslations);
  const educationLevelOptions = [
    {
      key: 0,
      value: "highSchoolDegree",
      text: t.people.personal_info_form.education_options.high_school,
    },
    {
      key: 1,
      value: "diplomaDegree",
      text: t.people.personal_info_form.education_options.diploma,
    },
    {
      key: 2,
      value: "bachelorsDegree",
      text: t.people.personal_info_form.education_options.bachelors,
    },
    {
      key: 3,
      value: "mastersDegree",
      text: t.people.personal_info_form.education_options.masters,
    },
    {
      key: 4,
      value: "doctorateDegree",
      text: t.people.personal_info_form.education_options.doctorate,
    },
    {
      key: 5,
      value: "other",
      text: t.people.personal_info_form.education_options.other,
    },
  ];
  const genderOptions = [
    {
      key: 0,
      value: "male",
      text: t.people.personal_info_form.gender_options.gender_male,
    },

    {
      key: 1,
      value: "female",
      text: t.people.personal_info_form.gender_options.gender_female,
    },
  ];
  const martialStatusOptions = [
    {
      key: 0,
      value: "single",
      text: t.people.personal_info_form.martial_option.single,
    },

    {
      key: 1,
      value: "married",
      text: t.people.personal_info_form.martial_option.married,
    },
  ];

  const [fetchLoading, setFetchLoading] = useState(false);

  const [activeModal, setActiveModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [toggleStatus, setToggleStatus] = useState(!targetedData?.blocked);
  const [updateModal, setUpdateModal] = useState(false);
  const [selectedPeopleWorkOrder, setSelectedPeopleWorkOrder] = useState([]);
  const [activeUsersList, setActiveUsersList] = useState([]);
  const [selectedUserToReAssign, setSelectedUserToReAssign] = useState("");
  const [data, setData] = useState({
    profile: {},
    attendence: {},
  });

  const [blocked, setBlocked] = useState(targetedData.blocked);

  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });

  const handleUnassignAndDeactivate = async () => {
    setLoading(true);
    let response = await DeactivatePeople("deactive", targetedData?.id, null);
    if (response && response.status == 200) {
      toast.success(t.people.security_form.user_deactivated);
      setTargetData({
        ...targetedData,
        blocked: true,
      });
      setUpdateModal(false);
      setBlocked(true);

      setSortData([]);
      setFilterOptions({
        role: [],
        supervisors: [],
        jobTitle: [],
        teams: [],
        status: [],

        rate: {
          from: null,
          to: null,
        },
      });
      setSearchTitle("");
      untoggle();
    } else if (response.status == 400) {
      if (response.error && response.error.message) {
        toast.error(response.error.message);
      } else {
        toast.error(t.common.something_wrong);
      }
      setToggleStatus(true);
    }
    setLoading(false);
  };

  const handleActivate = async () => {
    setLoading(true);
    let response = await DeactivatePeople("active", targetedData?.id, null);
    if (response && response.status == 200) {
      toast.success(t.people.security_form.user_activated);
      setTargetData({
        ...targetedData,
        blocked: false,
      });
      setActiveModal(false);
      setBlocked(false);
      setTogglePreviw(false);

      setSortData([]);
      setFilterOptions({
        role: [],
        supervisors: [],
        jobTitle: [],
        teams: [],
        status: [],

        rate: {
          from: null,
          to: null,
        },
      });
      setSearchTitle("");
    } else if (response.status == 400) {
      if (response.error && response.error.message) {
        toast.error(response.error.message);
      } else {
        toast.error(t.common.something_wrong);
      }
      setToggleStatus(false);
    }
    setLoading(false);
  };

  const handleReassignAndDeactivate = async () => {
    if (!selectedUserToReAssign) {
      toast.error(t.people.security_form.select_user);
      return;
    }
    setLoading(true);
    let response = await DeactivatePeople(
      "deactive",
      targetedData?.id,
      selectedUserToReAssign
    );
    if (response && response.status == 200) {
      toast.success(t.people.security_form.user_deactivated);
      setTargetData({
        ...targetedData,
        blocked: true,
      });
      setUpdateModal(false);
      setBlocked(true);

      setSortData([]);
      setFilterOptions({
        role: [],
        supervisors: [],
        jobTitle: [],
        teams: [],
        status: [],

        rate: {
          from: null,
          to: null,
        },
      });
      setSearchTitle("");
      untoggle();
    } else if (response.status == 400) {
      if (response.error && response.error.message) {
        toast.error(response.error.message);
      } else {
        toast.error(t.common.something_wrong);
      }
      setToggleStatus(true);
    }
    setLoading(false);
  };

  useEffect(() => {
    setFetchLoading(true);
    if (targetedData.userProfile) {
      setData({
        ...data,
        profile: targetedData.userProfile,
      });
      setFetchLoading(false);
    } else {
      setFetchLoading(false);
    }
  }, [targetedData]);

  let createdByName = createdByUserData ? (
    <div>
      <span>
        {createdByUserData?.firstName + " " + createdByUserData?.lastName}
      </span>
    </div>
  ) : (
    t.common.na
  );

  const educationLevel = educationLevelOptions.find(
    (one) => one.value === data.profile.educationLevel
  );
  const gender = genderOptions.find((one) => one.value === data.profile.gender);
  const martialStatus = martialStatusOptions.find(
    (one) => one.value === data.profile.martialStatus
  );

  const roles = [
    {
      key: 0,
      value: 5,
      text: t.people.add_modal.admin,

      description: t.people.add_modal.admin_description,
    },
    {
      key: 0,
      value: 4,
      text: t.people.add_modal.super_admin,
      description: t.people.add_modal.admin_description,
    },

    {
      key: 2,
      value: 9,
      text: t.people.add_modal.limited_admin,

      description: t.people.add_modal.limited_admin_description,
    },
    {
      key: 1,
      value: 8,
      text: t.people.add_modal.technician,

      description: t.people.add_modal.user_description,
    },

    {
      key: 3,
      value: 3,
      text: t.people.add_modal.viewer,

      description: t.people.add_modal.viewer_description,
    },
    {
      key: 2,
      value: 6,
      text: t.people.add_modal.requester,
      description: t.people.add_modal.requester_desc,
    },
  ];

  let role = roles.find((each) => each.value == targetedData?.role?.id);

  return (
    <div className="preview-details-wrapper">
      {fetchLoading ? (
        <Loader active inline="centered">
          {t.common.loading}
        </Loader>
      ) : (
        <>
          <div className="details-wrapper">
            <div className="d-flex align-items-start mt-5">
              <label className="workorder-intro-label personal-label">
                {t.people.personal_info_form.address}
                {":"}
              </label>
              <p className="workorder-intro-value">
                {data?.profile?.address ? data.profile.address : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-start mt-5">
              <label className="workorder-intro-label personal-label">
                {t.people.personal_info_form.gender}
                {":"}
              </label>
              <p className="workorder-intro-value">
                {gender?.text ? gender?.text : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-start mt-5">
              <label className="workorder-intro-label personal-label">
                {t.people.personal_info_form.martial_status}
                {":"}
              </label>
              <p className="workorder-intro-value">
                {martialStatus?.text ? martialStatus?.text : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-start mt-5">
              <label className="workorder-intro-label personal-label">
                {t.people.personal_info_form.number_of_dependents}
                {":"}
              </label>
              <p className="workorder-intro-value">
                {data?.profile?.childrenNo
                  ? data.profile.childrenNo
                  : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-start mt-5">
              <label className="workorder-intro-label personal-label">
                {t.people.personal_info_form.education_level}
                {":"}
              </label>
              <p className="workorder-intro-value">
                {educationLevel?.text ? educationLevel?.text : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-start mt-5">
              <label className="workorder-intro-label personal-label">
                {t.people.personal_info_form.filed_of_study}
                {":"}
              </label>
              <p className="workorder-intro-value">
                {data?.profile?.fieldOfStudy
                  ? data.profile.fieldOfStudy
                  : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-start mt-5">
              <label className="workorder-intro-label personal-label">
                {t.people.personal_info_form.nationality}
                {":"}
              </label>
              <p className="workorder-intro-value">
                {data?.profile?.nationality
                  ? Country.getCountryByCode(data?.profile?.nationality)?.name
                  : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-start mt-5">
              <label className="workorder-intro-label personal-label">
                {t.people.personal_info_form.country_of_birth}
                {":"}
              </label>
              <p className="workorder-intro-value">
                {data?.profile?.cob
                  ? Country.getCountryByCode(data?.profile?.cob)?.name
                  : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-start mt-5">
              <label className="workorder-intro-label personal-label">
                {t.people.personal_info_form.date_of_birth}
                {":"}
              </label>
              <p className="workorder-intro-value">
                {data?.profile?.dob
                  ? moment(data?.profile?.dob).format("DD/MM/YYYY")
                  : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-start mt-5">
              <label className="workorder-intro-label personal-label">
                {t.people.personal_info_form.passport_no}
                {":"}
              </label>
              <p className="workorder-intro-value">
                {data?.profile?.passportNo
                  ? data.profile.passportNo
                  : t.common.na}
              </p>
            </div>
            <div className="d-flex align-items-start mt-5">
              <label className="workorder-intro-label personal-label">
                {t.people.personal_info_form.identification_no}
                {":"}
              </label>
              <p className="workorder-intro-value">
                {data?.profile?.identificationNo
                  ? data.profile.identificationNo
                  : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-start mt-5">
              <label className="workorder-intro-label personal-label">
                {t.people.personal_info_form.visa_no}
                {":"}
              </label>
              <p className="workorder-intro-value">
                {data?.profile?.visaNo ? data.profile.visaNo : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-start mt-5">
              <label className="workorder-intro-label personal-label">
                {t.people.personal_info_form.visa_expire_date}
                {":"}
              </label>
              <p className="workorder-intro-value">
                {}
                {data?.profile?.visaExpireDate
                  ? moment(data?.profile?.visaExpireDate).format("DD/MM/YYYY")
                  : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-start mt-5">
              <label className="workorder-intro-label personal-label">
                {t.people.personal_info_form.emergency_contact}
                {":"}
              </label>
              <p className="workorder-intro-value">
                {data?.profile?.emergencyName
                  ? data.profile.emergencyName
                  : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-start mt-5">
              <label className="workorder-intro-label personal-label">
                {t.people.personal_info_form.emergency_phone}
                {":"}
              </label>
              <p className="workorder-intro-value">
                {data?.profile?.emergencyPhone
                  ? data.profile.emergencyPhone
                  : t.common.na}
              </p>
            </div>
          </div>

          <Modal
            size={selectedPeopleWorkOrder.length ? "" : "tiny"}
            className="assets-modal deactive-modal"
            open={updateModal}
            onClose={() => {
              setUpdateModal(false);
              setToggleStatus(true);
            }}
          >
            <div className="header-container">
              {selectedPeopleWorkOrder.length ? (
                <span className="assets-header">
                  {t.people.personal_info_form.assign}
                </span>
              ) : (
                <span className="assets-header">
                  {t.people.security_form.deactive}
                </span>
              )}
              <div>
                <span
                  className="c-pointer text-right"
                  onClick={() => {
                    setUpdateModal(false);
                    setToggleStatus(true);
                  }}
                >
                  <CloseIcon />
                </span>
              </div>
            </div>
            <Modal.Content>
              {selectedPeopleWorkOrder.length ? (
                <span className="assets-label cancel-child">
                  {targetedData.firstName + "(#" + targetedData.id + ") "}
                  {t.people.security_form.already_has_workorder}
                </span>
              ) : (
                <span className="assets-label cancel-child">
                  {t.people.security_form.make_deactive}
                </span>
              )}
              {selectedPeopleWorkOrder.length ? (
                <ul className="deactive_work_order_list">
                  {selectedPeopleWorkOrder.map((one) => {
                    return (
                      <li>
                        <p>
                          {one?.attributes?.title} {` (#${one.id})`}
                        </p>
                      </li>
                    );
                  })}
                </ul>
              ) : null}
              {selectedPeopleWorkOrder.length ? (
                <div className="d-flex mt-7">
                  <p className="status-modal-popup-message mt-3">
                    {t.people.security_form.re_assign_to}:{" "}
                  </p>
                  <Form.Field className="reAssign-field"
                  //  style={{ minHeight: "60px" }}
                   >
                    <Dropdown
                      
                      // style={{ width: "250px" }}
                      placeholder={t.people.security_form.select_one}
                      noResultsMessage={t.common.no_results_found}
                      selection
                      className="ml-4 reAssign-dropdown"
                      fluid
                      maxHeight={50}
                      upward
                      options={activeUsersList}
                      value={selectedUserToReAssign}
                      onChange={(e, value) =>
                        setSelectedUserToReAssign(value.value)
                      }
                    />
                  </Form.Field>
                </div>
              ) : null}
            </Modal.Content>
            {selectedPeopleWorkOrder.length ? (
              <div
                className={`modal-button-container mt-3 ${
                  selectedLanguage == "en" ? "mr-6" : "ml-10"
                }`}
              >
                <button
                  onClick={() => {
                    setUpdateModal(false);
                    setToggleStatus(true);
                  }}
                  // style={{ color: "black" }}
                  className="modal-form-action-button"
                >
                  {t.assets.form.cancel}
                </button>

                <button
                  onClick={handleUnassignAndDeactivate}
                  className="modal-form-action-button light-blue"
                >
                  {t.people.security_form.unassign}
                </button>

                <button
                  onClick={handleReassignAndDeactivate}
                  className="modal-form-action-button light-blue ml-1 mr-1  "
                >
                  {t.people.security_form.reassign}
                </button>
              </div>
            ) : (
              <div
                className={`modal-button-container mt-3 ${
                  selectedLanguage == "en" ? "mr-6" : "ml-10"
                }`}
              >
                <button
                  onClick={() => {
                    setUpdateModal(false);
                    setToggleStatus(true);
                  }}
                  // style={{ color: "black" }}
                  className="modal-form-action-button"
                >
                  {t.assets.form.cancel}
                </button>

                <button
                  onClick={() => handleUnassignAndDeactivate()}
                  className="modal-form-action-button light-blue"
                >
                  {t.assets.deactivate}
                </button>
              </div>
            )}
          </Modal>

          <Modal
            size="tiny"
            className="assets-modal"
            open={activeModal}
            onClose={() => {
              setActiveModal(false);
              setToggleStatus(false);
            }}
          >
            <div className="header-container">
              <span className="assets-header">
                {t.people.security_form.activete}
              </span>
              <div>
                <span
                  className="c-pointer text-right"
                  onClick={() => {
                    setActiveModal(false);
                    setToggleStatus(false);
                  }}
                >
                  <CloseIcon />
                </span>
              </div>
            </div>

            <Modal.Content>
              <span className="assets-label ml-1">
                {`${t.people.activate_statement} "${targetedData?.firstName} ${targetedData?.lastName}"`}
              </span>
            </Modal.Content>
            <div
              className={`modal-button-container mt-3 ${
                selectedLanguage == "en" ? "mr-6" : "ml-10"
              }`}
            >
              <button
                onClick={() => {
                  setActiveModal(false);
                  setToggleStatus(false);
                }}
                // style={{ color: "black" }}
                className="modal-form-action-button"
              >
                {t.assets.form.cancel}
              </button>

              <button
                onClick={() => handleActivate()}
                className="modal-form-action-button light-blue"
              >
                {t.assets.activate}
              </button>
            </div>
          </Modal>
        </>
      )}
    </div>
  );
}

export default Personal;
